export default "__VITE_ASSET__ca8204f1__"